/**
 * Build a stable client-side id from `prefix` + a random suffix.
 *
 * Uses crypto.randomUUID() when available (jsdom 16+, modern browsers);
 * falls back to Date.now() + Math.random() base36 so jsdom 14 specs and
 * ancient browsers don't throw.
 *
 * @param {string} prefix — short tag like 'fee', 'doc', or 'contract-asahi'
 * @returns {string}
 */
export const prefixedId = (prefix) => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID()}`
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
